import React from 'react';

interface FormattedTextProps {
	children: React.ReactNode
	formatClass?: string
	formatLinks?: boolean
	customStyle?: React.CSSProperties
  }

const FormattedText = ({ children, formatClass, customStyle, formatLinks }:FormattedTextProps) => {
	return (
		<div className={ `lhp-formatted-text ${formatClass} ${formatLinks ? 'format-links' : ''}` } style={ customStyle }>
			{ children }
		</div>
	);
};

export default FormattedText;